import classNames from "classnames";
import {CountryCode, getExampleNumber} from "libphonenumber-js";
import examples from "libphonenumber-js/examples.mobile.json";
import {useState} from "react";
import * as RIP from "react-international-phone";

import {defaultCountries} from "@/components/phone/PhoneInput.data.ts";

import styles from "@/components/phone/PhoneInput.module.scss";
import "react-international-phone/style.css";

const getPhonePlaceholder = (countryCode: string) => {
  const exampleNumber = getExampleNumber(countryCode.toUpperCase() as CountryCode, examples);
  if (exampleNumber) {
    return exampleNumber.formatInternational();
  }
  return "";
};

export const PhoneInput = (props: RIP.PhoneInputProps) => {
  const [country, setCountry] = useState("US" as CountryCode);

  const {inputValue} = RIP.usePhoneInput({
    defaultCountry: country.toLowerCase(),
    value: getPhonePlaceholder(country),
    disableDialCodeAndPrefix: props.disableDialCodeAndPrefix ?? true,
  });

  return (
    <RIP.PhoneInput
      {...props}
      countries={defaultCountries}
      defaultCountry={country.toLowerCase()}
      placeholder={props.placeholder ?? inputValue}
      onChange={(phone: string, meta: {country: RIP.ParsedCountry; inputValue: string}) => {
        setCountry(meta.country.iso2 as CountryCode);
        if (props.onChange) props.onChange(phone, meta);
      }}
      disableDialCodePrefill={props.disableDialCodePrefill ?? true}
      disableDialCodeAndPrefix={props.disableDialCodeAndPrefix ?? true}
      className={classNames(styles.PhoneListClassName, props.className, {
        [styles.invalid]: props.inputProps?.["aria-invalid"],
      })}
      inputClassName={classNames(styles.PhoneListInputClassName, props.inputClassName)}
      dialCodePreviewStyleProps={{
        className: styles.PhoneListDialCodePreviewClassName,
      }}
      countrySelectorStyleProps={{
        buttonClassName: styles.PhoneListCountrySelectorButtonClassName,
        dropdownArrowClassName: styles.PhoneListCountrySelectorDropdownArrowClassName,
        dropdownStyleProps: {
          className: styles.PhoneListCountrySelectorDropdownClassName,
        },
      }}
    />
  );
};
